module.exports = __webpack_public_path__ + "static/media/student37.d8b667c7.png";